// helpers/uuidHelpers.js
export function intToUuidString(id) {
  const s = id.toString().padStart(12, "0").slice(0, 12);
  return (
    s.slice(0, 8) +
    "-" +
    s.slice(8, 12) +
    "-" +
    s.slice(8, 12) +
    "-" +
    s.slice(8, 12) +
    "-" +
    s.padEnd(12, "0").slice(0, 12)
  );
}